<template>
	<div  class="leave-message-editor">
		<el-container class="leave-message-editor__box">
			  <el-header height="32px" style="padding: 0;">
				  <ul class="leave-message-editor__header">
					  <li @click="onTab(item)" v-for="(item,index) in tabs" :key="index" :class="{'active':active_tab == item.name}">
						  <i class="iconfont" :class="item.icon"></i>
						  <span>{{item.name}}</span>
					  </li>
				  </ul>
			  </el-header>
			  <el-container style="height: calc(100% - 32px);">
				<el-aside width="50%" class="leave-message-editor__input">
					<EditorTextareaView @finish="onFinish" :source="sourceViewer.source" v-if="active_tab == '文本'"/>
					<EditorImageView v-model="sourceViewer.source" :source="sourceViewer.source" @finish="onFinish" v-if="active_tab == '图片'"/>
					<EditorFastwordView @finish="onFinish" v-if="active_tab == '快捷话术'"/>
				</el-aside>
				<el-main class="leave-message-editor__preview">
					<div class="preview-box">
						<text-message :content="sourceViewer.source" v-if="sourceViewer.type == 'text'"></text-message>
						<image-message :src="$$(sourceViewer.source,'fileurl')" v-if="sourceViewer.type == 'image'"></image-message>
						<video-message :src="$$(sourceViewer.source,'url')" v-if="sourceViewer.type == 'video'"></video-message>
						<card-message :data="$$(sourceViewer.source)" v-if="sourceViewer.type == 'news'" keys="other"></card-message>
						<mini-program-message :data="sourceViewer.source" v-if="sourceViewer.type == 'miniprogrampage'"></mini-program-message>
					</div>
				</el-main>
			  </el-container>
		</el-container>
		<el-button size="mini" type="primary" class="send-btn" @click="onSubmit" :loading="loading">{{loading ? '发送中...' : '发送'}}</el-button>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import EditorTextareaView from './editorTextareaView';
	import EditorImageView from './editorImageView';
	import EditorFastwordView from './editorFastwordView';
	export default {
		components:{
			EditorTextareaView,
			EditorImageView,
			EditorFastwordView
		},
		computed:{
			...mapState({
				userId:state => state.user.userInfo.userId
			})
		},
		props:['sourceType','row_source'],
		data(){
			return {
				tabs:[
					{name: '文本',icon: 'major-wenben'},
					{name: '图片',icon: 'major-zujian-icon-35'},
					{name: '快捷话术',icon: 'major-huashuku'}
				],
				active_tab:'文本',
				sourceViewer:{
					source:null,
					type:''
				},
				loading:false
			}
		},
		methods:{
			onSubmit(){
				if(!this.sourceViewer.source) return this.$notify.warning('发送消息不能为空');
				let params = {
					msg: '',
					attachment:'',
					miniProgram:'',
					news:'',
				};
				switch(this.sourceViewer.type){
					case 'text':
						params.msg = this.sourceViewer.source;
						break;
					case 'image':
					case 'video':
						params.attachment = {
							fileId:this.sourceViewer.source.id,
							filename:this.sourceViewer.source.filename,
							filetype:this.sourceViewer.source.filetype,
							url:this.sourceViewer.source.fileurl,
							filesize:this.sourceViewer.source.filesize,
						}
						break;
					case 'miniprogrampage':
						params.miniProgram = {
							appid:this.sourceViewer.source.appid,
							pagepath:this.sourceViewer.source.pagepath,
							thumb_media_id:this.sourceViewer.source.thumbMediaId,
							title:this.sourceViewer.source.title,
							id:this.sourceViewer.source.id
						}
						break;
					case 'news':
						params.news = {
							description:this.sourceViewer.source.content,
							id:this.sourceViewer.source.attachment.id,
							picurl:this.sourceViewer.source.attachment.fileurl,
							title:this.sourceViewer.source.name,
							url:this.sourceViewer.source.attachment.newsurl
						}
						break;
						
				}
				
				if(this.sourceType){
					this.$emit('onSave',Object.assign({type:this.sourceViewer.type},params));
					return
				}
				this.loading = true;
				let querys = {
					brand:this.row_source.childBrand || this.row_source.brand,
					channel:this.row_source.channel,
					msg_id:uuidv4(),
					sender_id:this.userId,
					sender_type:2,
					sendtime:new Date().getTime(),
					skillGroup:this.row_source.skillGroup,
					type:this.sourceViewer.type,
					session_id:this.row_source.session
				}
				let real_params = Object.assign(querys,params);
				this.$api.receveImLeaveMessageItem(real_params).then(res => {
					this.loading = false
					if(res.errcode != 0) return;
					this.$notify.success('回复留言成功');
					this.$emit('confirm',this.row_source.session);
					this.$emit('loadHistory',this.row_source.user);
					this.sourceViewer.source = '';
					this.sourceViewer.type = '';
					
					
				}).catch(err => {
					this.loading = false
				})
			},
			onTab(source){
				this.active_tab = source.name;
				this.sourceViewer.source = '';
				this.sourceViewer.type = '';
			},
			onFinish(souce){
				this.sourceViewer = souce;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.leave-message-editor {
		height: 100%;
		font-size: 12px;
		color: #6C7E91;
		.send-btn {
			float: right;
		    margin-top: 20px;
		}
		&__box {
			border: 1px solid #D8D8D8;
			height: calc(100% - 100px);
			border-radius: 4px;
		}
	
		&__header {
			display: flex;
			align-items: center;
			height: 100%;
			background: #F2F2F2;
			padding:0 18px;
			li {
				list-style: none;
				margin-right: 40px;
				display: flex;
				align-items: center;
				cursor: pointer;
				.iconfont {
					font-size: 12px;
					margin-right: 3px;
				}
				&.active {
					color:#337EFF ;
				}
			}
		}
		&__input {
			padding: 0;
			background: none;
			border-right: 1px solid #DCDFE6;
		}
		&__preview {
			padding: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			
			.preview-box {
				max-height: 100%;
				width: 95%;
				padding: 20px;
				background: #D8D8D8;
				border-radius: 10px;
				position: relative;
				word-break: break-all;
				&::before {
					display: inline-block;
					position: absolute;
					content: "";
					width: 0;
					height: 0;
					border-top: 5px solid transparent;
					border-right: 5px solid #D8D8D8;
					border-bottom: 5px solid transparent;
					border-left: 5px solid transparent;
					left: -9px;
					top: 15px;
				}
				::v-deep {
					.chat-miniprogram-message {
						background-color: #fff;
					}
				}
			}
		}
	}
</style>